/**
 * This reducer is used for storing GridData
 */
import { SET_SHIP_TO_ADDRESS_DETAILS } from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
const initialState = {
    gridData: [],
};

const gridDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SHIP_TO_ADDRESS_DETAILS:
            return {
                ...state,
                gridData: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'gridDataKey',
        storage: storage,
    },
    gridDataReducer
);
